import { useMemo } from 'react';
import { LayoutDashboard, Users, Megaphone, Terminal, Settings, UserCog2, ShieldAlert, Bell, Wallet, TrendingUp } from 'lucide-react';
import DesktopNav from './DesktopNav';
import MobileNav from './MobileNav';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../../hooks/useAppSelector';

export const SideNav = () => {
  const location = useLocation();
  const role = useAppSelector((state) => state.auth.user?.role);

  const navItems = useMemo(() =>
    role === 'admin' ? [
      {
        label: 'Dashboard',
        icon: <LayoutDashboard size={20} />,
        href: '/dashboard',
        id: 'dashboard',
      },
      { label: 'Results', icon: <Users size={20} />, href: '/results', id: 'results' },
      { label: 'API', icon: <Terminal size={20} />, href: '/api', id: 'api' },
      {
        label: 'Advertisers',
        icon: <UserCog2 size={20} />,
        href: '/advertisers',
        id: 'advertisers',
      },
      {
        label: 'Finance',
        icon: <Wallet size={20} />,
        href: '/finance',
        id: 'finance',
      },
      {
        label: 'Revenue',
        icon: <TrendingUp size={20} />,
        href: '/revenue',
        id: 'revenue',
      },
      {
        label: 'DNC Audit',
        icon: <ShieldAlert size={20} />,
        href: '/dnc-audit',
        id: 'dnc-audit',
      },
      {
        label: 'Notifications',
        icon: <Bell size={20} />,
        href: '/notifications',
        id: 'notifications',
      },
      {
        label: 'Account',
        icon: <Settings size={20} />,
        href: '/account',
        id: 'account',
      },
    ] : [
      {
        label: 'Dashboard',
        icon: <LayoutDashboard size={20} />,
        href: '/dashboard',
        id: 'dashboard',
      },
      {
        label: 'Campaigns',
        icon: <Megaphone size={20} />,
        href: '/campaigns',
        id: 'campaigns',
      },
      { label: 'Results', icon: <Users size={20} />, href: '/results', id: 'results' },
      { label: 'API', icon: <Terminal size={20} />, href: '/api', id: 'api' },
      {
        label: 'Account',
        icon: <Settings size={20} />,
        href: '/account',
        id: 'account',
      },
    ], [role]);

  const currentTab = useMemo(() => {
    // Check for exact match first
    const tab = navItems.find((item) => location.pathname === item.href);
    if (tab) return tab.id;
    // Check for prefix match (e.g., /finance/refunds should highlight Finance)
    const prefixTab = navItems.find((item) => location.pathname.startsWith(item.href + '/'));
    return prefixTab ? prefixTab.id : 'dashboard';
  }, [location.pathname, navItems]);

  return (
    <>
      <DesktopNav items={navItems} currentTab={currentTab} />
      <MobileNav items={navItems} currentTab={currentTab} />
    </>
  );
};
